import featherlightGallery from 'featherlight/release/featherlight.gallery.min.js'
import "featherlight/release/featherlight.min.css";
import "featherlight/release/featherlight.gallery.min.css";

import Swiper, { Navigation, Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';

import '../plugins/swiped-events.js';

if($('.clickable').length > 0) {
    $('.clickable').featherlightGallery({
        previousIcon: '<i class="fal fa-angle-left"></i>',
        nextIcon: '<i class="fal fa-angle-right"></i>',
        galleryFadeIn: 300,

        openSpeed: 300
    });
}

if($('.gallery-block--layout-8').length > 0) {
    const gallery = $('.gallery-block--layout-8');
    const count = gallery.find('.image').length - 1;
    const images = gallery.find('.image');
    let activeImage = gallery.find('.image.active');
    let offset = 0;

    gallery.find('.image_0').addClass('active');

    let data = {
        offset: offset,
        count: count,
        images: images,
        gallery: gallery,
    }

    $('.gallery-block .next').on('click', e => {
        data = nextImage(data);
    });
    $('.gallery-block .prev').on('click', e => {
        data = prevImage(data);
    });

    const wrapper = document.querySelector('.gallery-block__wrapper');

    document.addEventListener('swiped-left', function(e) {
        if(e.target === wrapper) {
            data = nextImage(data);
        }
    });

    document.addEventListener('swiped-right', function(e) {
        if(e.target === wrapper) {
            data = prevImage(data);
        }
    });
}

function nextImage(data){
    if(data.offset === data.count-4) {
        // gallery.css('transition', 'none');
        data.offset = 0;
        $(data.images).each((index, image) => {
            if(index === 0) {
                $(image).removeClass('hidden');
                $(image).addClass('active');
            } else {
                $(image).removeClass('active');
                $(image).removeClass('hidden');
            }
        });
    } else {
        // gallery.css('transition', '.5s width');
        data.offset++;
        data.gallery.find('.image_' + data.offset).addClass('active');
        data.gallery.find('.image.active.image_' + (data.offset-1)).addClass('hidden').removeClass('active');
        data.gallery.toggleClass('shift')
    }

    return data;
}

function prevImage(data){
    if(data.offset === 0) {
        // gallery.css('transition', 'none');
        data.offset = data.count - 4;
        $(data.images).each((index, image) => {
            if(index < (data.count - 4)) {
                $(image).addClass('hidden');
            } else if(index === (data.count - 4)) {
                $(image).addClass('active');
            }
        });
    } else {
        // gallery.css('transition', '.5s width');
        data.offset--;

        data.gallery.find('.image.active').removeClass('active');
        data.gallery.find('.image_' + data.offset).addClass('active').removeClass('hidden');

        data.gallery.toggleClass('shift')
    }

    return data;
}

if($('.gallery-block--layout-9').length > 0) {
    Swiper.use([Navigation, Autoplay ]);
    const gallerySwiper = new Swiper('.gallery-swiper', {
        loop: true,
        slidesPerView: 1,
        autoplay: {
          // delay: 1000,
          disableOnInteraction: false,
        },
        // centeredSlides: true,
        spaceBetween: 20,
        allowTouchMove: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }
    });
}
